export enum DriverCardField {
    ID = "id",
    CARD_ID = "driverCardId",
    DEVICE_ID = "deviceId",
    SLOT = "slot",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
    DELETED_AT = "deletedAt",
}
